import React, { useEffect, useState } from 'react';
import ViewWrapperWithCommandBar from '../../../Layout/ViewWrapperWithCommandBar';
import Wizard from '../../../Wizard/Wizard';
import { DefaultPalette, ICommandBarItemProps, ISelectableOption, Text } from '@fluentui/react';
import { titleCommandBarButtonStyles, defaultCommandBarButtonStyles } from '../../../../styles/button-styles';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../common/constants';
import { DateTime } from 'luxon';
import TimeTaxSupportSystemClient from '../../../../system';
import MessageCourier from '../../../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../system/User';
import { LiquidacionInsumo } from '../../../../system/settlement/aje/liquidacion-insumos';
import { LiquidacionAsincronaV2, LiquidacionAsincronaV2CreatePayload } from '../../../../system/liquidacion_asincrona/LiquidacionAsincronaV2System';
import {
  AgrupadorCorporacionLiquidadora,
  AgrupadorCorporacionLiquidadoraTipo,
} from '../../../../system/agrupador_corporacion_liquidadora/AgrupadorCorporacionLiquidadoraSystem';
import GenerateReportHoursSettlement from './GenerateReportHoursSettlement';
import PeriodReportHoursSettlement from './PeriodReportHoursSettlement';
import {
  BillableDistributionTemplateItem,
  ReportHoursSettlementEstado,
  SolicitudExportacionReporteAsincrona,
} from '../../../../system/report_hours_settlement/ReportHoursSettlementSystem';
import CostDerivationReportHoursSettlement from './CostDerivationReportHoursSettlement';

interface ISettlementsViewAjeProps {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: any;
  user: User;
}
export const DISTRIBUCION_PROYECTOS = 'P';
export const DISTRIBUCION_ACTIVIDADES = 'A';
export const DISTRIBUCION_HIBRIDA = 'H';

const CreateReportHoursSettlementView = (props: ISettlementsViewAjeProps) => {
  const { t } = useTranslation();
  const [canGoNext, setCanGoNext] = useState(false);

  const [month, setMonth] = useState<DateTime>(DateTime.now());

  const [liquidacionInsumosList, setLiquidacionInsumosList] = useState<LiquidacionInsumo[]>([]);
  const [generatedResponse, setGeneratedResponse] = useState<SolicitudExportacionReporteAsincrona>();
  const [lastConfirmatedSettlement, setLastConfirmatedSettlement] = useState<String>();

  const [settlementType, setSettlementType] = useState<ISelectableOption<AgrupadorCorporacionLiquidadora>>({ key: '', text: '' });
  const [billableDistributionTemplate, setBillableDistributionTemplate] = useState<BillableDistributionTemplateItem[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (month && settlementType && settlementType.key) {
      getPreliquidacionReport();
    }
  }, [month, settlementType]);

  const generateSettlement = async () => {
    if (month) {
      props.changeBlockUI(true);
      try {
        const periodo = month.toFormat('yyyyLL');
        const ahora = DateTime.local();
        const fechaFormateada = ahora.toFormat('yyyy-MM-dd HH:mm:ss');

        console.log('fechaFormateada', fechaFormateada);

        const payload: SolicitudExportacionReporteAsincrona = {
          sexpasinc_periodo: periodo,
          sexpasinc_agrcorliq_tipo: String(settlementType.data),
          sexpasinc_solicitud_colid: Number(props.user.getCollaboratorId()),
          sexpasinc_aceptado_colid: null,
          sexpasinc_eliminado_colid: null,
          sexpasinc_activo: 1,
          sexpasinc_estado: ReportHoursSettlementEstado.REGISTRADO,
          sexpasinc_fecha_creacion: fechaFormateada,
          sexpasinc_fecha_ejecucion: fechaFormateada,
        };

        const data = await props.system.getReportHoursSettlementSystem().create(payload);
        props.courier.messageSuccess(t('Se iniciará la generación del reporte'));
        setGeneratedResponse(data);
        setButtonDisability(false);
        navigate(routes.report_hours_settlement);
      } catch (error) {
        props.courier.messageError(error);
      } finally {
        props.changeBlockUI(false);
      }
    }
  };

  const getPreliquidacionReport = async () => {
    if (month) {
      if (!settlementType || !settlementType.key) {
        props.courier.messageError(t('Debe seleccionar un tipo de liquidación antes de continuar'));
        return;
      }

      props.changeBlockUI(true);
      props.courier.messageError('');
      try {
        // setLiquidacionInsumosList([]);

        const periodo = month.toFormat('yyyyLL');

        const existsResponse = await props.system.getReportHoursSettlementSystem().existsByPeriodo({
          sexpasinc_periodo: periodo,
          sexpasinc_agrcorliq_tipo: String(settlementType?.data),
        });

        if (existsResponse.existe) {
          setCanGoNext(false);
          props.courier.messageError(t('Ya existe una solicitud activa para el período seleccionado'));
          return;
        } else {
          setCanGoNext(true);
        }
      } catch (error: any) {
        props.courier.messageError(error?.message || error);
      } finally {
        props.changeBlockUI(false);
      }
    }
  };

  const periodString = () => {
    return month.toFormat('LL/yyyy');
  };

  const Titles = [t('1. Período'), t('2. Derivación de costos'), t('3. Generar reporte')];
  const Descriptions = [
    t('Elije el periodo y el tipo de liquidación correspondientes para generar el próximo reporte.'),
    t('En esta sección podrás revisar y modificar la plantilla de derivación de costos.'),
    t('Generar reporte.'),
  ];

  const setButtonDisability = (can: boolean) => {
    setCanGoNext(can);
  };

  const itemsMenu = React.useMemo(
    (): ICommandBarItemProps[] => [
      {
        key: 'title',
        text: t('Horas cuantificadas'),
        iconProps: {
          iconName: 'TableComputed',
          color: DefaultPalette.themeLighterAlt,
          className: 'text-title-btn',
        },
        buttonStyles: titleCommandBarButtonStyles,
        className: 'text-title-btn',
      },
      {
        key: 'back',
        text: t('Volver'),
        onClick: () => navigate(`${routes.report_hours_settlement}`),
        iconProps: { iconName: 'Back' },
        buttonStyles: defaultCommandBarButtonStyles,
      },
    ],
    [navigate],
  );

  const getDataFromCompanySelectorAssistant = (month: DateTime) => {
    setMonth(month);
  };

  const hasSettlementItems = () => {
    if (liquidacionInsumosList.length > 0) {
      return true;
    } else if (liquidacionInsumosList.length < 1) {
      return false;
    } else {
      return null;
    }
  };

  const Selectors = [
    <PeriodReportHoursSettlement
      system={props.system}
      courier={props.courier}
      getDataFromCompanySelectorAssistant={getDataFromCompanySelectorAssistant}
      setButtonDisability={setButtonDisability}
      hasItems={hasSettlementItems()}
      month={month}
      lastSettlement={lastConfirmatedSettlement}
      setSettlementType={setSettlementType}
      settlementType={settlementType}
    />,
    <CostDerivationReportHoursSettlement
      system={props.system}
      courier={props.courier}
      setButtonDisability={setButtonDisability}
      period={periodString()}
      generateSettlement={generateSettlement}
      billableDistributionTemplate={billableDistributionTemplate}
      setBillableDistributionTemplate={setBillableDistributionTemplate}
      settlementType={settlementType}
      from={month}
      user={props.user}
    />,
    <GenerateReportHoursSettlement
      system={props.system}
      courier={props.courier}
      setButtonDisability={setButtonDisability}
      period={periodString()}
      generateSettlement={generateSettlement}
      generatedSettlementResponse={generatedResponse}
      settlementType={settlementType}
      billableDistributionTemplate={billableDistributionTemplate}
      from={month}
      user={props.user}
    />,
  ];

  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={''}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="highligth"
      titleBody={t('Proyectos')}
    >
      <div className="padding-1">
        <div className="ms-Grid bg-white-h100" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 mt-2 ml-1 defense-file-container-desc">
              <Text className="ml-10px defense-file-title d-block">{t('Asistente para la generación de reportes mensuales')}</Text>
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ml-1"></div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <Wizard
                componentsTitlesArray={Titles}
                componentsDescriptions={Descriptions}
                componentsArray={Selectors}
                canGoNext={canGoNext}
                hiddenButtons={!!generatedResponse}
              />
            </div>
          </div>
        </div>
      </div>
    </ViewWrapperWithCommandBar>
  );
};

export default CreateReportHoursSettlementView;
